import { SchemaTypesEnum } from '@spazious/dollhouse-fsetup';
import {
  IconBanquetDuotone,
  IconBoardroomDuotone,
  IconCabaretDuotone,
  IconClassroomDuotone,
  IconCocktailDuotone,
  IconDesktopDuotone,
  IconMeetingDuotone,
  IconTheatreDuotone,
  IconUShapeDuotone,
  SvgIconProps,
} from '@spazious/dollhouse-icons';

export const fcompositionSchemaIconMapping: Record<SchemaTypesEnum, React.FC<SvgIconProps>> = {
  // TODO fix types from icons
  [SchemaTypesEnum.FEnsembleDesktop]: IconDesktopDuotone as any,
  [SchemaTypesEnum.FEnsembleRound]: IconBanquetDuotone as any,
  [SchemaTypesEnum.FEnsembleCabaret]: IconCabaretDuotone as any,
  [SchemaTypesEnum.FEnsembleBoardroom]: IconMeetingDuotone as any,
  [SchemaTypesEnum.FArrangementTheater]: IconTheatreDuotone as any,
  [SchemaTypesEnum.FArrangementRound]: IconBanquetDuotone as any,
  [SchemaTypesEnum.FArrangementClassroom]: IconClassroomDuotone as any,
  [SchemaTypesEnum.FArrangementCabaret]: IconCabaretDuotone as any,
  [SchemaTypesEnum.FArrangementCocktail]: IconCocktailDuotone as any,
  [SchemaTypesEnum.FArrangementBoardroom]: IconBoardroomDuotone as any,
  [SchemaTypesEnum.FArrangementUshape]: IconUShapeDuotone as any,
};
